<!-- 会员权益 -->
<template>
  <div class="item1_box">
    <div class="content" v-html="info.content"></div>
    <!-- <div class="fj_box">
			<div>相关附件:</div>
			<div>
				<div class="one_file">
					<div class="doc" @click="download">1：{{fjInfo.name}}.doc</div>
					<div class="iconfont icon-xiazai" @click="download"></div>
				</div>
			</div>
		</div> -->
  </div>
</template>

<script>
import { getSingleArticle } from "@/api/home/party";
import { getLinks } from "@/api/home/index";
export default {
  components: {},
  data() {
    return {
      info: {},
      fjInfo: {},
    };
  },
  mounted() {
    this.getSingleArticle();
    // this.getLinks();
  },
  methods: {
    getSingleArticle() {
      getSingleArticle({
        catid: 212,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.info = res.result;
        }
      });
    },
    getLinks() {
      getLinks({
        type: 11,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.fjInfo = res.result;
        }
      });
    },
    download() {
      window.open(this.fjInfo.resource);
    },
  },
};
</script>

<style lang="scss" scoped>
.item1_box {
  .title {
    font-size: 22px;
    text-align: center;
  }

  .time {
    font-size: 12px;
    padding: 50px 0 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    width: 100%;
  }
}
.fj_box {
  display: flex;
  align-items: flex-start;
  font-size: 18px;
  white-space: nowrap;
  .doc {
    cursor: pointer;
    color: #164eb9;
    margin: 0 20px;
  }
  .iconfont {
    cursor: pointer;
    color: #164eb9;
    font-size: 24px;
  }
  .one_file {
    display: flex;
    align-items: center;
    margin-top: -5px;
    margin-bottom: 20px;
  }
}
</style>
